"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdaptableObjectRow = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
/// <reference path="../../typings/.d.ts" />
const rebass_1 = require("rebass");
const join_1 = tslib_1.__importDefault(require("../../../components/utils/join"));
class AdaptableObjectRow extends React.Component {
    render() {
        const colItems = this.props.colItems.map((colItem, index) => (React.createElement(rebass_1.Text, { className: "ab-AdaptableObjectRow__cell", "data-name": "list-group-cell", key: index, title: typeof colItem.Content === 'string' ? colItem.Content : undefined, flex: colItem.Size, paddingLeft: 1, paddingRight: 1 }, colItem.Content)));
        const className = (0, join_1.default)('ab-AdaptableObjectRow', this.props.isSuspended && 'ab-AdaptableObjectRow--is-suspended');
        return (React.createElement(rebass_1.Flex, { className: className, onClick: this.props.onClick, style: this.props.style }, colItems));
    }
}
exports.AdaptableObjectRow = AdaptableObjectRow;
